const MINUTE = 60
const HOUR = 60 * MINUTE

/** Format a heartbeat-derived duration for the usage table. */
export function formatTimeSpent(seconds: number): string {
  if (!Number.isFinite(seconds) || seconds <= 0) return '0m'
  if (seconds < HOUR) return `${Math.round(seconds / MINUTE)}m`
  const hours = Math.floor(seconds / HOUR)
  const minutes = Math.round((seconds % HOUR) / MINUTE)
  if (minutes === 0) return `${hours}h`
  return `${hours}h ${minutes}m`
}

export function formatAvgTurns(value: number): string {
  if (!Number.isFinite(value) || value <= 0) return '0'
  return value.toFixed(1).replace(/\.0$/, '')
}

export interface UsageUserCount {
  userId: string
  value: number
}

/** Users with a positive count for one feature/action, highest first. */
export function usersWithKeyedCount<T extends { user_id: string }>(
  users: T[],
  valueForUser: (user: T) => number
): UsageUserCount[] {
  return users
    .map((user) => ({ userId: user.user_id, value: valueForUser(user) }))
    .filter((row) => row.value > 0)
    .sort((a, b) => b.value - a.value || a.userId.localeCompare(b.userId))
}
